import React from "react";

export default function ServioSvgIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="115"
            height="115"
            viewBox="0 0 115 115"
            {...props}
        >
            <g transform="translate(-26 -45)">
                <circle
                    cx="57.5"
                    cy="57.5"
                    r="57.5"
                    transform="translate(26 45)"
                    fill={props.stopColor}
                />
                <g transform="translate(53 72)">
                    {/* Bell/Service Icon */}
                    <path
                        d="M30.5 0C31.8807 0 33 1.11929 33 2.5V8C33 8 42 12 42 28H48C49.6569 28 51 29.3431 51 31V35C51 36.6569 49.6569 38 48 38H13C11.3431 38 10 36.6569 10 35V31C10 29.3431 11.3431 28 13 28H19C19 12 28 8 28 8V2.5C28 1.11929 29.1193 0 30.5 0Z"
                        fill={props.fill}
                    />
                    {/* Bell Base */}
                    <path
                        d="M24 42H37C37 46.4183 34.0899 50 30.5 50C26.9101 50 24 46.4183 24 42Z"
                        fill={props.fill}
                    />
                    {/* Sound Waves */}
                    <path
                        d="M5 20C5 20 0 24 0 31C0 38 5 42 5 42"
                        stroke={props.fill}
                        strokeWidth="3"
                        strokeLinecap="round"
                        fill="none"
                    />
                    <path
                        d="M56 20C56 20 61 24 61 31C61 38 56 42 56 42"
                        stroke={props.fill}
                        strokeWidth="3"
                        strokeLinecap="round"
                        fill="none"
                    />
                    {/* Small notification dot */}
                    <circle cx="45" cy="10" r="6" fill={props.fill} />
                </g>
            </g>
        </svg>
    );
}
